<div class="grid grid-cols-2 lg:grid-rows-2 lg:grid-cols-1 gap-2">
  <button libButton variant="primary" class="w-full" [disabled]="applyDisabled()" (click)="onApplyClick()">
    <div class="grid grid-cols-[auto_1fr] items-center w-full">
      <mat-icon class="size-4!" svgIcon="check"></mat-icon>
      <span class="self-center">{{ 'EDITOR.BUTTONS.APPLY' | translate }}</span>
    </div>
  </button>
  <button libButton variant="muted" class="w-full" (click)="onCancelClick()">
    <div class="grid grid-cols-[auto_1fr] items-center w-full">
      <mat-icon class="size-4!" svgIcon="times"></mat-icon>
      <span>{{ 'EDITOR.BUTTONS.CANCEL' | translate }}</span>
    </div>
  </button>
</div>
